import { render, staticRenderFns } from "./BannerShortcutCreate.vue?vue&type=template&id=ee20fc68&"
import script from "./BannerShortcutCreate.vue?vue&type=script&lang=js&"
export * from "./BannerShortcutCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports